// VALM CUSTOM: Native TOC disclosure defaults, section count, and Theme Editor selection.
if (!customElements.get('valm-article-toc')) {
  class ValmArticleToc extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;

      const countElement = this.querySelector('.valm-article-toc__count');
      const sectionCount = new Set(
        Array.from(this.querySelectorAll('.valm-article-toc__content a[href^="#"]'))
          .map(link => link.getAttribute('href'))
          .filter(href => href.length > 1)
      ).size;
      if (countElement && sectionCount) {
        const label = sectionCount === 1 ? this.dataset.sectionSingular : this.dataset.sectionPlural;
        countElement.textContent = `${sectionCount} ${label}`;
        countElement.hidden = false;
      }

      this.mobileQuery = window.matchMedia('(max-width: 767.98px)');
      this.applyViewportDefault = () => { this.details.open = !this.mobileQuery.matches && this.dataset.collapseDesktop === 'false'; };
      this.applyViewportDefault();
      this.mobileQuery.addEventListener('change', this.applyViewportDefault);

      if (window.Shopify?.designMode) {
        this.onBlockSelect = event => {
          if (event.target instanceof Element && event.target.contains(this)) this.details.open = true;
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      this.mobileQuery?.removeEventListener('change', this.applyViewportDefault);
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
  }
  customElements.define('valm-article-toc', ValmArticleToc);
}
